import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustSignals = () => {
  const securityFeatures = [
    {
      icon: 'Shield',
      title: 'Bank-Level Security',
      description: '256-bit SSL encryption protects your data'
    },
    {
      icon: 'Lock',
      title: 'Secure Authentication',
      description: 'Multi-factor authentication available'
    },
    {
      icon: 'CheckCircle',
      title: 'Regulatory Compliance',
      description: 'FCA regulated and PCI DSS compliant'
    }
  ];

  const certifications = [
    {
      name: 'PCI DSS',
      description: 'Payment Card Industry Data Security Standard',
      icon: 'CreditCard'
    },
    {
      name: 'ISO 27001',
      description: 'Information Security Management',
      icon: 'FileCheck'
    },
    {
      name: 'FCA Regulated',
      description: 'Financial Conduct Authority',
      icon: 'Building'
    }
  ];

  return (
    <div className="space-y-8">
      {/* Security Features */}
      <div className="bg-card rounded-lg border border-border p-6">
        <h3 className="text-lg font-semibold text-foreground mb-4 flex items-center">
          <Icon name="Shield" size={20} className="text-primary mr-2" />
          Your Security is Our Priority
        </h3>
        <div className="space-y-4">
          {securityFeatures?.map((feature, index) => (
            <div key={index} className="flex items-start space-x-3">
              <div className="w-8 h-8 bg-primary/10 rounded-full flex items-center justify-center flex-shrink-0">
                <Icon name={feature?.icon} size={16} className="text-primary" />
              </div>
              <div>
                <h4 className="text-sm font-medium text-foreground">{feature?.title}</h4>
                <p className="text-xs text-muted-foreground">{feature?.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Certifications */}
      <div className="bg-card rounded-lg border border-border p-6">
        <h3 className="text-lg font-semibold text-foreground mb-4">Regulatory Compliance</h3>
        <div className="grid grid-cols-1 gap-4">
          {certifications?.map((cert, index) => (
            <div key={index} className="flex items-center space-x-3 p-3 bg-muted/50 rounded-md">
              <Icon name={cert?.icon} size={20} className="text-primary flex-shrink-0" />
              <div>
                <div className="text-sm font-medium text-foreground">{cert?.name}</div>
                <div className="text-xs text-muted-foreground">{cert?.description}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Support Information */}
      <div className="bg-card rounded-lg border border-border p-6">
        <h3 className="text-lg font-semibold text-foreground mb-4 flex items-center">
          <Icon name="Headphones" size={20} className="text-primary mr-2" />
          Need Help?
        </h3>
        <div className="space-y-3">
          <div className="flex items-center space-x-3">
            <Icon name="Phone" size={16} className="text-muted-foreground" />
            <span className="text-sm text-foreground">+1 (555) 123-4567</span>
          </div>
          <div className="flex items-center space-x-3">
            <Icon name="Mail" size={16} className="text-muted-foreground" />
            <span className="text-sm text-foreground">support@moneytransfer.com</span>
          </div>
          <div className="flex items-center space-x-3">
            <Icon name="Clock" size={16} className="text-muted-foreground" />
            <span className="text-sm text-foreground">24/7 Customer Support</span>
          </div>
        </div>
      </div>
      {/* SSL Badge */}
      <div className="text-center">
        <div className="inline-flex items-center space-x-2 bg-success/10 text-success px-4 py-2 rounded-full border border-success/20">
          <Icon name="Lock" size={16} />
          <span className="text-sm font-medium">SSL Secured Connection</span>
        </div>
      </div>
    </div>
  );
};

export default TrustSignals;